export default __webpack_public_path__ + "static/media/goal-forms.301512ae.svg";